module.exports = __webpack_public_path__ + "img/its_logo_horizontal_black.d312df0d.jpg";